import SmallPopupTemplate from "components/templates/modal/small/SmallPopupTemplate";
import * as s from "./ExportMailStyled";
import EmailSelectComponent from "components/atoms/select/email/EmailSelectComponent";
import { ExportEmailRequest } from "api/interfaces/reportInterface.interface";
import { useCallback, useState } from "react";
import TextArea from "components/atoms/input/TextArea";
import { Text, ValidateWord } from "components/atoms/text/Text";
import Input from "components/atoms/input/Input";
import { checkEmailRegEx } from "utils/regEx";
import { useMutation } from "react-query";
import { notify } from "components/atoms/notification/Notification";
import { sendExportEmail } from "api/reportAPI";
import { ProfileAccountInfo } from "api/interfaces/accountInterface.interface";
import { useAppSelector } from "redux/hooks";
import { BasePagination } from "api/interfaces/commonInterface.interface";
import useApiError from "hook/useApiError";
import { checkEmpty } from "utils/functions";

type ExportEmailProps = {
  reportId: string;
  title: string | undefined;
  onModal: () => void;
  recorderPaginationInfo: BasePagination;
  cameraPaginationInfo: BasePagination;
};

//TODO RND-340
export default function ExportMail(props: ExportEmailProps): JSX.Element {
  const { intlString, lang, notifySuccess } = useApiError();
  const selectedAccount: ProfileAccountInfo = useAppSelector(
    (state) => state.accountSettings
  );
  const [isValid, setIsValid] = useState<boolean>(true);
  const [isValidEmail, setIsValidEmail] = useState<boolean>(true);
  const [state, setState] = useState<ExportEmailRequest>({
    email: [],
    title: props.title !== undefined ? props.title : "",
    message: "",
    reportId: props.reportId,
  });

  const onSelectUser = (emails: string[]) => {
    setState({
      ...state,
      email: emails,
    });
  };

  const mutationExportEmail = useMutation(sendExportEmail, {
    onSuccess: () => {
      notifySuccess(lang.label.common.notify.email.success);
      props.onModal();
    },
    onError: () => {
      notify("error", lang.ServerErrorCode[121014]);
    },
  });

  const onClickSend = useCallback(() => {
    setIsValid(true);
    setIsValidEmail(true);
    if (state.email.length === 0) {
      setIsValid(false);
      return;
    }

    const isAllValid = state.email.every(
      (email) => !checkEmpty(email) && checkEmailRegEx(email)
    );
    if (!isAllValid) {
      setIsValidEmail(false);
      return;
    }

    mutationExportEmail.mutate({
      accountId: selectedAccount.accountId,
      payload: {
        email: state.email,
        title: state.title,
        message: state.message,
        reportId: state.reportId,
        recorderSortDto: {
          sortType: props.recorderPaginationInfo.sortType,
          sortDirection: props.recorderPaginationInfo.sortDirection,
        },
        cameraSortDto: {
          sortType: props.cameraPaginationInfo.sortType,
          sortDirection: props.cameraPaginationInfo.sortDirection,
        },
      },
    });
  }, [
    mutationExportEmail,
    props.cameraPaginationInfo.sortDirection,
    props.cameraPaginationInfo.sortType,
    props.recorderPaginationInfo.sortDirection,
    props.recorderPaginationInfo.sortType,
    selectedAccount.accountId,
    state.email,
    state.message,
    state.reportId,
    state.title,
  ]);

  const onChangeMessage = (e: any) => {
    setState({
      ...state,
      message: e.target.value,
    });
  };

  const onChangeTitle = (e: any) => {
    setState({
      ...state,
      title: e.target.value,
    });
  };
  return (
    <SmallPopupTemplate
      title="Send Email"
      subTitle="Export Inventory Report"
      onClick={onClickSend}
      onModal={props.onModal}
      confirmLabel="Send"
      className="full-width"
      data-testid="reports-view-export-small-popup-template-click-send"
    >
      <s.EmailSelectContainer>
        <EmailSelectComponent
          value={state.email}
          //placeholder="Select User or Enter Email Address"
          onChange={onSelectUser}
          isVs
          placeholder={intlString(lang.label.report.send.email.placeholder)}
          // isSelectedArr={state.user}
        />
      </s.EmailSelectContainer>

      <s.MessageOptional>
        <Text fontSize={18}>Title</Text>
        <Input
          name="title"
          value={state.title}
          onChange={onChangeTitle}
          placeholder="Please enter a title"
          data-testid="reports-view-export-title-change-title"
        />
      </s.MessageOptional>
      <s.MessageOptional>
        <Text fontSize={18}>Message (Optional)</Text>
        <TextArea
          name="message"
          value={state.message}
          onChange={onChangeMessage}
          placeholder="Please enter a message."
          data-testid="reports-view-export-message-change-message"
        />
      </s.MessageOptional>
      {!isValid && (
        <ValidateWord data-testid="reports-view-export-validate-email">
          {intlString(lang.validateMsg.videoShare.err.emptyUser)}
        </ValidateWord>
      )}

      {!isValidEmail && (
        <ValidateWord data-testid="reports-view-export-validate-email-invalid">
          {intlString(lang.validateMsg.videoShare.err.invalidEmail)}
        </ValidateWord>
      )}
    </SmallPopupTemplate>
  );
}
